export const activeTabObject = {
  TEST_INFO: {
    index: 0,
    name: 'TEST_INFO',
    alias: 'info'
  },
  SPECIMENS_AND_SAMPLES: {
    index: 1,
    name: 'SPECIMENS_AND_SAMPLES',
    alias: 'specimens-and-samples'
  },
  QC_RESULTS: {
    index: 2,
    name: 'QC_RESULTS',
    alias: 'qc-results'
  },
  GENOMIC_ABERRATIONS: {
    index: 3,
    name: 'GENOMIC_ABERRATIONS',
    alias: 'aberrations'
  },
  THERAPY_MATCH: {
    index: 4,
    name: 'THERAPY_MATCH',
    alias: 'therapy'
  },
  THERAPY_PRIORITIZE: {
    index: 4,
    name: 'THERAPY_PRIORITIZE',
    alias: 'prioritize'
  },
  CLINICAL_TRAILS: {
    index: 5,
    name: 'CLINICAL_TRAILS',
    alias: 'trials'
  },
  TEST_SUMMARY: {
    index: 6,
    name: 'TEST_SUMMARY',
    alias: 'test-summary'
  },
  REPORT_PREVIEW: {
    index: 6,
    name: 'REPORT_PREVIEW',
    alias: 'reportPreview'
  },
  CASE_SUMMARY: {
    index: 7,
    name: 'CASE_SUMMARY',
    alias: 'case-summary'
  },

  PATHWAY_SELECTION: {
    index: 1,
    name: 'PATHWAY_SELECTION',
    alias: 'pathway-selection'
  },
  THERAPY_PRIORITIZATION: {
    index: 3,
    name: 'THERAPY_PRIORITIZATION',
    alias: 'therapy-prioritization'
  },
  COLLECT_DATA: {
    index: 3,
    name: 'COLLECT_DATA',
    alias: 'collect-data'
  },
  COMPLETE_PLAN: {
    index: 4,
    name: 'COMPLETE_PLAN',
    alias: 'COMPLETE_PLAN'
  },
  DOCUMENTS_PREVIEW: {
    index: 4,
    name: 'DOCUMENTS_PREVIEW',
    alias: 'documents-preview'
  }
};

export const buttonsNamesEnum = {
  'NONE':0,
  'ACCEPT_CASE':1,
  'UNASSIGN_CASE':2,
  'SIGN_OFF':3,
  'SIGN_OFF_HIDE':4
};

